// Display formatters for Notice Management (PRD 13 §4.3).

// NID display: `N-` + zero-padded integer (3 digits, e.g. N-001, N-010, N-100).
export function formatNid(id: number): string {
  return `N-${String(id).padStart(3, '0')}`;
}

// `createdAt` (ISO 8601 UTC) → `YYYY.MM.DD HH:MM` (24h, local time).
export function formatNoticeDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}.${p(d.getMonth() + 1)}.${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
